import { formatEditorMiddleInitial } from '@/utils/editor-text-box/editorTextBoxAdapter'

/**
 * The middle name as every text box paints it, TinyMCE and Lotus alike: as
 * written, with a period added after a lone initial. One rule, so an authored
 * name part never reads differently between the two editors.
 */
export const formatMiddleInitial = (value: string): string =>
  formatEditorMiddleInitial(value)
